export default "__VITE_ASSET__HtBa7D0F__"